import { loadComments } from "../../../../helper/externalApi";

export const commentsPageSize = 5;

export default async function handler(req, res) {
  const { id, page } = req.query;
  const json = await loadComments(id, page, commentsPageSize);
  res.status(200).json(json);
}
